export default __webpack_public_path__ + "static/media/medsure-circle.4308d8e8.webp";